// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#personFrame {
  margin-bottom: 20px;
}

.invertUnderline {
  text-decoration: none;
}

.invertUnderline:hover {
  text-decoration: underline;
}

.personFrameHeader {
  padding: 5px;
  background-color: white;
}

.mainContent {
  padding: 0px;
}

.nameTitle {
  font-size: 17pt;
  padding-left: 6px;
  position: absolute;
  padding-top: 9px;
}

.nameTitleCard {
  font-size: 15pt;
  padding: 9px 4px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.main-container {
  padding: 10px;
  height: 250px;
  overflow-y: hidden;
  width: 100%;
}

.competenciesGraphTd {
  width: 110px;
}

.competenciesTd {
  width: 100%;
}

.subCard {
  z-index: 0;
  background-color: white;
  width: 100%;
  position: absolute;
}

.cardHeaderMainTitle {
  font-family: MontserratBold, sans-serif;
  padding-top: 10px;
}

.cardHeader {
  width: auto;
  background-color: rgb(206, 206, 206);
  border-bottom: 2px solid #999;
  padding: 4px 4px 4px 10px;
  height: 50px;
}

.cardHeader * {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.trucateWidth {
  width: calc(100% - 170px);
}

.card {
  z-index: 3;
  background-color: white;
}

.leftCard {
  border-left: 6px solid #F7F5F2;
  margin-right: 4px;
}

.middleCard {
  margin-right: 2px;
  margin-left: 2px;
}

.rightCard {
  border-right: 6px solid #F7F5F2;
  margin-left: 4px;
}

.cardContainer {
  padding-right: 0;
  padding-left: 0;
}

p {
  padding-bottom: 0;
}

.textBox {
  width: 100%;
  text-align: center;
}

.score {
  color: #007566;
  font-size: 150%;
}

.block {
  background-color: #EDF2F5;
  padding: 18px 10px 10px 10px;
  width: calc(50% - 4px);
  height: 90px;
}

.iacOverlay {
  position: absolute;
  width: calc(100% - 4px);
  background-color: white;
  height: 250px;
  opacity: 0.65;
}

.fakeItem {
  background-color: #dddddd;
  line-height: 12px;
}

.fakeIndicator {
  color: #dddddd;
}

.fakeListTable {
  width: 100%;
}

.fakeListTable tr {
  height: 20px;
}

.fakeListTable tr td:last-child {
  width: 20px;
}

.notCompleted {
  position: absolute;
  height: 250px;
  width: calc(100% - 4px);
  font-family: sans-serif;
  font-size: 20px;
  fill: rgb(86, 86, 86);
}

.notCompletedTxt {
  margin: auto;
  width: -moz-fit-content;
  width: fit-content;
  margin: 95px auto 0 auto;
}

.btn-person-card:focus-visible, .btn-person-card:focus, .btn-person-card.focus {
  background-color: #fff;
  outline: none;
  border-color: #ccc;
}

.cards {
  float: left;
  position: relative;
  width: 100%;
  background-color: white;
}

.cardsGrid {
  padding-bottom: 2px;
}

.cardGridView {
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/jobSatisfactions/components/commonClasses/job-satisfactions-person-card/job-satisfactions-person-card.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAEA;EACI,YAAA;EACA,uBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,UAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,uCAAA;EACA,iBAAA;AACJ;;AAEA;EACI,WAAA;EACA,oCAAA;EACA,6BAAA;EACA,yBAAA;EACA,YAAA;AACJ;;AAEA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,UAAA;EACA,uBAAA;AACJ;;AAEA;EACI,8BAAA;EACA,iBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,+BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAIA;EACI,WAAA;EACA,kBAAA;AADJ;;AAIA;EACI,cAAA;EACA,eAAA;AADJ;;AAIA;EACI,yBAAA;EACA,4BAAA;EACA,sBAAA;EACA,YAAA;AADJ;;AAIA;EACI,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AADJ;;AAIA;EACI,yBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;AADJ;;AAIA;EACI,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,wBAAA;AADJ;;AAIA;EACI,sBAAA;EACA,aAAA;EACA,kBAAA;AADJ;;AAIA;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,YAAA;AADJ","sourcesContent":["#personFrame {\n    margin-bottom: 20px;\n}\n\n.invertUnderline {\n    text-decoration: none;\n}\n\n.invertUnderline:hover {\n    text-decoration: underline;\n}\n\n.personFrameHeader {\n    padding: 5px;\n    background-color: white;\n}\n\n.mainContent {\n    padding: 0px;\n}\n\n.nameTitle {\n    font-size: 17pt;\n    padding-left: 6px;\n    position: absolute;\n    padding-top: 9px;\n}\n\n.nameTitleCard {\n    font-size: 15pt;\n    padding: 9px 4px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.main-container {\n    padding: 10px;\n    height: 250px;\n    overflow-y: hidden;\n    width: 100%;\n}\n\n.competenciesGraphTd {\n    width: 110px;\n}\n\n.competenciesTd {\n    width: 100%;\n}\n\n.subCard {\n    z-index: 0;\n    background-color: white;\n    width: 100%;\n    position: absolute;\n}\n\n.cardHeaderMainTitle {\n    font-family: MontserratBold,  sans-serif;\n    padding-top: 10px;\n}\n\n.cardHeader {\n    width: auto;\n    background-color: rgb(206, 206, 206);\n    border-bottom: 2px solid #999;\n    padding: 4px 4px 4px 10px;\n    height: 50px;\n}\n\n.cardHeader * {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.trucateWidth {\n    width: calc(100% - 170px);\n}\n\n.card {\n    z-index: 3;\n    background-color: white;\n}\n\n.leftCard {\n    border-left: 6px solid #F7F5F2;\n    margin-right: 4px;\n}\n\n.middleCard {\n    margin-right: 2px;\n    margin-left: 2px;\n}\n\n.rightCard {\n    border-right: 6px solid #F7F5F2;\n    margin-left: 4px;\n}\n\n.cardContainer {\n    padding-right: 0;\n    padding-left: 0;\n}\n\np {\n    padding-bottom: 0;\n}\n\n\n\n.textBox {\n    width: 100%;\n    text-align: center;\n}\n\n.score {\n    color: #007566;\n    font-size: 150%;\n}\n\n.block {\n    background-color: #EDF2F5;\n    padding: 18px 10px 10px 10px;\n    width: calc(50% - 4px);\n    height: 90px;\n}\n\n.iacOverlay {\n    position: absolute;\n    width: calc(100% - 4px);\n    background-color: white;\n    height: 250px;\n    opacity: 0.65;\n}\n\n.fakeItem {\n    background-color: #dddddd;\n    line-height: 12px;\n}\n\n.fakeIndicator {\n    color: #dddddd;\n}\n\n.fakeListTable {\n    width: 100%;\n}\n\n.fakeListTable tr {\n    height: 20px;\n}\n\n.fakeListTable tr td:last-child {\n    width: 20px;\n}\n\n.notCompleted {\n    position: absolute;\n    height: 250px;\n    width: calc(100% - 4px);\n    font-family: sans-serif;\n    font-size: 20px;\n    fill: rgb(86, 86, 86);\n}\n\n.notCompletedTxt {\n    margin: auto;\n    width: fit-content;\n    margin: 95px auto 0 auto;\n}\n\n.btn-person-card:focus-visible, .btn-person-card:focus, .btn-person-card.focus {\n    background-color: #fff;\n    outline: none;\n    border-color: #ccc;\n}\n\n.cards {\n    float: left;\n    position: relative;\n    width: 100%;\n    background-color: white;\n}\n\n.cardsGrid {\n    padding-bottom: 2px;\n}\n\n.cardGridView {\n    margin: auto;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
